import React, { Component } from "react";
import axios from "axios";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Switch from "@mui/material/Switch";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { observer, inject } from "mobx-react";
import LinearProgress from "@mui/material/LinearProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Divider from "@mui/material/Divider";
import ClearIcon from "@mui/icons-material/Clear";
import { Table, TableBody, TableHead, TableRow, TableCell } from "@mui/material";
import { blue, grey } from "@mui/material/colors";
import moment from "moment";

import { divProgressHide, divProgressShow } from "../../css/additional.js";

import {
  getCurrentChild,
  getCurrentOrg,
  getSpecials,
  getCurrentInvoice,
  getAllOrg,
  invoicesUrl,
  api2ChildSendInvitationToCabinet,
  api2ChildSendFutureInvoice,
  api2ChildTransferParentsToSchool,
  api2ChildShow, api2ChildVaccineRecords,
  api2ClassesByOrganizationId,
  api2ChildGetPlans,
  api2ChildSyncPlans,
} from "../../utils/operations.js";

import {
  api2ChildDelete,
  api2ChildGetFutureInvoice, api2ChildLogFinance,
  api2ChildPatch,
  api2ChildUpdateInvoice
} from "../../utils/operations";

import API from '../../utils/api';
import { toast } from 'react-toastify';
import appRoutes from "../../utils/appRoutes";
import {ExpandedField} from "../../components/ExpandedField";

const AriaModal = require("react-aria-modal");

class EditChild extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        id: "",
        photo: "",
        photofile: "",
        firstname: "",
        lastname: "",
        organisation: "",
        classes: "",
        parent: "",
        birthday: new Date(),
        programs: "",
        _created: null,
        startdate: new Date(),
        dropdate: null,
        status: "",
        parent_id: "",
        usephoto: false,
        acs: false,
        memo: "",
        afterschool: "",
        futuredepo: 0,
        nextyeardepo: 0
      },
      futuredepoOriginal: 0,
      nextyeardepoOriginal: 0,
      datasource: [],
      plans: [],
      plansChanged: false,
      organisations: [],
      parents: [],
      emergency: [],
      medicalRecords: [],
      vaccineRecords: [],
      specials: [],
      programs: [],
      classes: [],
      currentOrgClasses: [],
      billParent: "",
      opendialog: false,
      texterrors: "",
      showProgress: true,
      showParents: false,
      showEmergency: false,
      showSpecials: false,
      showMedicalRecords: false,
      test: "hide",
      changeSchool: 1,
      changeClass: '',
      gotOrgClasses: [],
      gotClasses: [],
      showFutureInvoice: false,
      pdfFile: this.props.Auth.pdfFile,
      invoiceData: null,
      invoiceId: null,
      programFilterValue: '',
      showTransferModal: false,
      transferWitParents: true,
    };
  }

  handleOpen = () => {
    this.setState({ opendialog: true });
  };

  handleClose = () => {
    this.setState({ showProgress: false });
    this.setState({ opendialog: false });
  };

  componentDidMount() {
    if (!this.props.Auth.child_id) {
      this.props.Auth.child_id = this.props.match.params.id;
    }
    this.setState({ changeSchool: this.props.Auth.orgId });
    this.loadData();
    this.forceUpdate();
  }

  componentWillUnmount() {
    this.props.Auth.pdfFile = "";
  }

  loadData = () => {
    this.setState({ showProgress: true });
    let orgId = this.props.Auth.orgId;
    let childId = this.props.match.params.id;

    let that = this;

    axios
      .all([
        API.get(api2ChildShow(childId), {
          params: {
            with: 'emergency,medicalRecords,vaccineRecords',
          }
        }),
        API.get(getCurrentOrg + orgId),
        API.get(api2ClassesByOrganizationId(orgId)),
        API.get(getAllOrg + "?related=classes_by_organisation_id"),
        API.get(invoicesUrl + `?fields=id%2Cpaid&filter=child_id%3D${childId}&limit=1`),
        API.get(api2ChildVaccineRecords(childId))
      ])
      .then(
        axios.spread(function(
          child,
          organisations,
          classes,
          allschools,
          invoice,
          vaccine_records
        ) {
          const data = child.data.data;
          const vaccineRecords = vaccine_records.data.data;
          const organisation = organisations.data;
          const gotClasses = classes.data.data;
          const gotOrgClassesRaw = allschools.data.resource;
          const invoiceData = invoice.data.resource.length > 0 ? invoice.data.resource[0] : null;
          const invoiceId = invoiceData ? invoiceData.id : null;
          const changeClass = gotClasses.length ? gotClasses[0].id : 0;

          const currentOrgClasses = gotOrgClassesRaw.find((org) => org.id === data.organisation_id).classes_by_organisation_id

          data.organisation = organisation.name;
          data.orgID = organisation.id;

          data._created
            ? (data._created = new Date(data._created))
            : (data._created = null);
          data.startdate
            ? (data.startdate = new Date(data.startdate))
            : (data.startdate = null);
          data.dropdate
            ? (data.dropdate = new Date(data.dropdate))
            : (data.dropdate = null);
          data.birthday
            ? (data.birthday = new Date(data.birthday))
            : (data.birthday = null);

          that.setState({
            data: data,
            futuredepoOriginal: data.futuredepo,
            nextyeardepoOriginal: data.nextyeardepo,
            organisations: gotOrgClassesRaw,
            showProgress: false,
            classes: gotClasses,
            gotClasses,
            changeClass: changeClass,
            currentOrgClasses: currentOrgClasses,
            invoiceData: invoiceData,
            invoiceId,
            emergency: data.emergency,
            medicalRecords: data.medical_records,
            vaccineRecords: vaccineRecords,
          });
          that.forceUpdate();
        })
      )
      .catch(function(error) {
        toast.error('Some thing wrong!' + error);
      });

    this.loadPlans(childId);
    this.loadParents(childId);
    this.loadSpecials(childId);

    this.setState({ showProgress: false });
  };

  loadParents = childId => {
    let that = this;
    let ctp = getCurrentChild + childId + "?related=parents_by_childtoparent";

    API.get(ctp)
      .then(res => {
        let parents = res.data.parents_by_childtoparent;
        that.setState({ parents });
      });
  };

  loadPlans = async itemId => {
    const response = await API.get(api2ChildGetPlans(itemId));
    const plans = response.data.data;
    this.setState({ plans });
    this.forceUpdate();
  };

  loadSpecials = childId => {
    let url = getSpecials + "/?filter=child_id%3D" + childId.toString();

    API.get(url)
      .then(res => {
        let specials = res.data.resource;
        if (specials.length > 0) {
          this.setState({ specials });
        }
      });
  };


  deleteData = async () => {
    this.setState({ opendialog: false });
    let that = this;
    let child_id = this.state.data.id;

    try {
      await API.delete(api2ChildDelete(child_id))
      toast.success('Child deleted successfully!');
      that.props.history.push("/children");
    } catch (e) {
      toast.error('Some thing wrong!');
    }

  };

  deleteCurrentBill = async () => {
    await API.delete(getCurrentInvoice + this.state.invoiceId.toString())
  };

  saveData = async () => {
    this.setState({ showProgress: true });
    let child = { ...this.state.data };

    child.startdate
      ? (child.startdate = moment(child.startdate).format("YYYY-MM-DD"))
      : (child.startdate = null);
    child.birthday
      ? (child.birthday = moment(child.birthday).format("YYYY-MM-DD"))
      : (child.birthday = null);

    if (child.dropdate) {
      let compareDate =
        moment(child.dropdate).format("YYYY-MM-DD") <=
        moment().format("YYYY-MM-DD");
      if (compareDate && this.state.invoiceId && this.state.invoiceData.paid === 0) {
        await this.deleteCurrentBill();
      }

      child.dropdate = moment(child.dropdate).format("YYYY-MM-DD");
    } else {
      child.dropdate = null;
    }

    let data = {
      firstname: child.firstname,
      lastname: child.lastname,
      organisation_id: child.organisation_id,
      parent_id: child.parent_id,
      classes_id: child.classes_id,
      birthday: child.birthday,
      startdate: child.startdate,
      dropdate: child.dropdate,
      usephoto: child.usephoto,
      afterschool: child.afterschool,
      status: child.status,
      acs: child.acs,
      futuredepo: child.futuredepo,
      nextyeardepo: child.nextyeardepo,
      memo: child.memo
    };

    try {
      const futuredepoDiff = +child.futuredepo - this.state.futuredepoOriginal
      const nextyeardepoDiff = +child.nextyeardepo - this.state.nextyeardepoOriginal

      await API.patch(api2ChildPatch(child.id), data)

      if (futuredepoDiff > 0) {
        await API.post(api2ChildLogFinance(child.id), { amount: futuredepoDiff, type: 'futuredepo' })
      }

      if (nextyeardepoDiff > 0) {
        await API.post(api2ChildLogFinance(child.id), { amount: nextyeardepoDiff, type: 'nextyeardepo' })
      }
    } catch (error) {
      toast.error(error.response.data.error)
      return false;
    }

    if (this.state.plansChanged) {
      const planIds = this.state.plans
        .filter(p => p.toggled)
        .map(p => p.id);

      try {
        await API.post(api2ChildSyncPlans(this.state.data.id), { plan_ids: planIds });
      } catch (error) {
        toast.error(error.response?.data?.error || 'Error saving programs');
      }
    }

    toast.success('Child edited successfully!');
    setTimeout(this.props.history.push("/children"), 1000);
  };

  usePhoto = () => {
    let data = this.state.data;
    data.usephoto = !data.usephoto;
    this.setState({ data });
  };

  setACS = () => {
    let data = this.state.data;
    data.acs = !data.acs;
    this.setState({ data });
  };

  handleAfterschool = e => {
    let data = this.state.data;
    data.afterschool = e.target.value;
    this.setState({ data });
  };

  handleClassChange = event => {
    const data = this.state.data;
    data.classes_id = event.target.value;
    this.setState({ data });
  };

  handleChange = event => {
    const data = this.state.data;
    data[event.target.id] = event.target.value;
    this.setState({ data });
  };

  handleBirthday = birthday => {
    const data = this.state.data;
    data.birthday = birthday;
    this.setState({ data });
  };

  handleStartDate = startDate => {
    const data = this.state.data;
    data.startdate = startDate;
    this.setState({ data });
  };

  handleDropDate = dropDate => {
    const data = this.state.data;
    data.dropdate = dropDate;
    this.setState({ data });
  };

  goPreviousPage = () => {
    this.props.Auth.child_id = null;
    setTimeout(this.props.history.push("/children"), 1000);
  };

  handleToggle = e => {
    let plans = this.state.plans;
    let name = e.target.name;

    for (let i = 0; i < plans.length; i++) {
      if (plans[i].id === Number(name)) {
        plans[i].toggled = !plans[i].toggled;
      }
    }

    this.setState({ plans, plansChanged: true });
  };

  handleRemoveDropDate = () => {
    const data = this.state.data;
    data.dropdate = null;
    this.setState({ data });
  };

  addParent = () => {
    this.props.Auth.addParentToChildId = this.state.data.id;
    const newUrl = "/newparent";
    setTimeout(this.props.history.push(newUrl), 1000);
  };

  addEmergency = () => {
    const newUrl = "/editemergency/:new";
    setTimeout(this.props.history.push(newUrl), 1000);
  };

  addMedicalRecord = () => {
    const childId = this.props.Auth.child_id;
    const newUrl = appRoutes.addMedicalRecord(childId)
    setTimeout(this.props.history.push(newUrl), 1000);
  };

  addVaccineRecord = () => {
    const childId = this.props.Auth.child_id;
    const newUrl = appRoutes.childAddVaccineRecord(childId)
    setTimeout(this.props.history.push(newUrl), 1000);
  };

  editSpecials = () => {
    const childId = this.props.Auth.child_id;
    const newUrl = appRoutes.editSpecialNeeds(childId)
    setTimeout(this.props.history.push(newUrl), 1000);
  };

  editParent = id => {
    const editUrl = "/editparent/" + id;
    setTimeout(this.props.history.push(editUrl), 1000);
  };

  editEmergency = id => {
    const editUrl = "/editemergency/:" + id;
    setTimeout(this.props.history.push(editUrl), 1000);
  };

  editMedicalRecord = id => {
    const childId = this.props.Auth.child_id;
    const editUrl = appRoutes.editMedicalRecord(childId, id);
    setTimeout(this.props.history.push(editUrl), 1000);
  };

  editVaccineRecord = (vaccineRecordId, childVaccineRecordId) => {
    const childId = this.props.Auth.child_id;
    const editUrl =  childVaccineRecordId ? appRoutes.childEditVaccineRecord(childId, childVaccineRecordId)
      : appRoutes.childAddVaccineRecord(childId, vaccineRecordId);
    setTimeout(this.props.history.push(editUrl), 1000);
  };

  refreshInvoice = async () => {
    const childId = this.props.Auth.child_id;

    if (!window.confirm('Are you sure ? \nThis action will regenerate invoice with applied changes!')) return;

    try {
      const result = await API.get(api2ChildUpdateInvoice(childId))
      toast.success("Invoice was updated successfully")
      setTimeout(() => {
        window.open(result.data.file)
      }, 1000);
    } catch (e) {
      toast.error("Something wrong. Please try again.")
    }
  };

  sendInvitation = async () => {
    const childId = this.props.Auth.child_id;

    if (!window.confirm('Are you sure ? \nAll parents of this child will receive invitations!')) return;

    try {
      await API.get(api2ChildSendInvitationToCabinet(childId))
      toast.success("Invitation was sent successfully")
    } catch (e) {
      toast.error(e.response.data.error)
    }
  };

  sendFutureInvoice = async () => {
    if (!window.confirm('This action will generate and send an invoice to the parent(s). \nAre you sure?')) return;

    try {
      const childId = this.props.Auth.child_id
      await API.get(api2ChildSendFutureInvoice(childId))
      toast.success("Invoice was sent successfully")
    } catch (e) {
      toast.error(e.response.data.error)
    }
  };

  viewFutureInvoice = async () => {
    const childId = this.props.Auth.child_id

    try {
      const result = await API.get(api2ChildGetFutureInvoice(childId))
      setTimeout(() => {
        window.open(result.data.file)
      }, 100);
    } catch (e) {
      toast.error("Something wrong. Please try again.")
    }
  };

  handleTransferClick = () => {
    if (!this.state.changeClass) {
      return toast.error("Please, select class.")
    }

    this.setState({ showTransferModal: true })
  }

  transferChildApi2 = async () => {
    const childId = this.props.match.params.id
    const data = {
      organisation_id: this.state.changeSchool,
      classes_id: this.state.changeClass,
    }

    try {
      await API.patch(api2ChildPatch(childId), data)

      if (this.state.transferWitParents) {
        await API.post(api2ChildTransferParentsToSchool(childId), {organisation_id: this.state.changeSchool})
      }

      toast.success("Child transferred successfully!")
    } catch (e) {
      toast.error("Something wrong. Please try again.")
    }

    this.props.Auth.setOrgId(this.state.changeSchool)
    this.props.Auth.getOrgName()

    setTimeout(this.props.history.push("/children"), 1000)
  }

  handleOrgChange = event => {
    const value = event.target.value;
    const data = this.state.data;
    data.organisation = value;
    data.classes = "";
    this.setState({ data });

    const org = this.state.organisations.find(o => o.id === +value);
    const currentOrgClasses = org ? org.classes_by_organisation_id : [];
    this.setState({ changeSchool: value, changeClass: '', gotClasses: currentOrgClasses, currentOrgClasses });
  };

  // Обработка Memo
  handleMemo = event => {
    const data = this.state.data;
    data.memo = event.target.value;
    this.setState({ data });
  };

  render() {
    const transferModal = this.state.showTransferModal ? (
      <AriaModal
        titleText="Child Transfer Confirmation"
        getApplicationNode={() => document.getElementById('root')}
        underlayStyle={{ paddingTop: '2em', zIndex: 1500 }}
        onExit={() => this.setState({ showTransferModal: false })}
        focusDialog
      >
        <div
          style={{
            background: "#fff",
            outline: 0,
            minWidth: 450,
            maxWidth: 700,
            padding: 50,
            borderRadius: 4
          }}
        >
          <h2>Child Transfer Confirmation</h2>
          <div style={{ fontSize: '18px', marginBottom: '30px' }}>
            Are you sure ?
            <br />This will transfer child to another school and class!
            <br /><br />Please, recreate invoice if need after this action.
            <br />
            <br />
            <FormControlLabel
              style={{ marginBottom: 16 }}
              control={
                <Checkbox
                  checked={this.state.transferWitParents}
                  onChange={() => this.setState({ transferWitParents: !this.state.transferWitParents })}
                />
              }
              label="Transfer Parents to New School"
            />
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between'}}>
            <Button variant="contained" color="primary" onClick={this.transferChildApi2}>Confirm</Button>
            <Button variant="contained" onClick={() => this.setState({ showTransferModal: false })}>Close</Button>
          </div>

        </div>
      </AriaModal>
    ) : null;

    const dialogActions = (
      <>
        <Button onClick={this.handleClose}>Cancel</Button>
        <Button color="primary" onClick={this.deleteData}>OK</Button>
      </>
    );

    return (
      <div className="child">
        <br />
        <div style={this.state.showProgress ? divProgressShow : divProgressHide}>
          <LinearProgress />
        </div>

        {/* Transfer section */}
        <div style={{ marginBottom: 24 }}>
          <span>Select school transfer to:</span>
          <div style={{ marginTop: 12 }} className="childTransfer">
            <FormControl fullWidth>
              <InputLabel id="school-transfer-label">School</InputLabel>
              <Select
                labelId="school-transfer-label"
                value={this.state.changeSchool ?? ''}
                onChange={this.handleOrgChange}
                label="School"
              >
                {Object.values(this.props.Auth.allOrgs).map(org => (
                  <MenuItem key={org.id} value={org.id}>{org.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="class-transfer-label">Class</InputLabel>
              <Select
                labelId="class-transfer-label"
                value={this.state.changeClass ?? ''}
                onChange={e => this.setState({ changeClass: e.target.value })}
                label="Class"
              >
                {this.state.gotClasses.map(row => (
                  <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <div>
              <Button variant="contained" onClick={this.handleTransferClick}>Transfer</Button>
            </div>
          </div>
        </div>

        {/* Relational sections */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <ExpandedField title='Parents' onAddClick={this.addParent}>
            {this.state.parents.map(row => (
              <div key={row.id}>
                <Button variant="text" color="primary" onClick={() => this.editParent(row.id)}>
                  {row.firstname + " " + row.lastname}
                </Button>
                <br />
                <span style={{ color: grey[400] }}>Email: </span>{" "}
                <span>{row.email}</span>
                <br />
                <span style={{ color: grey[400] }}>Phone 1: </span>{" "}
                <span>{row.phone}</span>
                <br />
                <span style={{ color: grey[400] }}>Phone 2: </span>{" "}
                <span>{row.phone2}</span>
                <br />
                <span style={{ color: grey[400] }}>Phone 3: </span>{" "}
                <span>{row.phone3}</span>
                <br />
                {row.organisation_id !== this.state.data.organisation_id && <div className='text--error'>Different organisation! Please fix!</div>}
                <br />
              </div>
            ))}
          </ExpandedField>

          <ExpandedField title='Emergency contacts' onAddClick={this.addEmergency}>
            {this.state.emergency.map(row => (
              <p key={row.id}>
                <Button variant="text" color="primary" onClick={() => this.editEmergency(row.id)}>
                  {row.name + ' - ' + (row.relation ? row.relation : '')}
                </Button>
                <br />
                <span style={{ color: grey[400] }}>Phone: </span>{" "}
                <span>{row.phone}</span>
                <br />
              </p>
            ))}
          </ExpandedField>

          <ExpandedField title='Allergies and Special needs'>
            {this.state.specials.map(row => (
              <p key={row.id}>
                <span style={{ color: grey[400] }}>Allergies: </span>{" "}
                <span>{row.allergies}</span>
                <br />
                <span style={{ color: grey[400] }}>Special needs: </span>{" "}
                <span>{row.additionally}</span>
              </p>
            ))}
            <Button variant="text" color="primary" onClick={this.editSpecials}>Edit Additional Info</Button>
          </ExpandedField>

          <ExpandedField title='Medical Records' onAddClick={this.addMedicalRecord}>
            <Table size="small">
              <TableBody>
                {this.state.medicalRecords.map(row => (
                  <TableRow key={row.id} onMouseDown={() => this.editMedicalRecord(row.id)} style={{cursor: 'pointer'}}>
                    <TableCell>{row.title}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{row.expiration_date}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </ExpandedField>
          <ExpandedField title='Vaccine Records'>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Title</TableCell>
                  <TableCell style={{ textAlign: 'center' }}>Doses completed</TableCell>
                  <TableCell style={{ textAlign: 'center' }}>Expiration date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.vaccineRecords.map(row => (
                  <TableRow
                    key={row.vaccine_record_id}
                    onMouseDown={() => this.editVaccineRecord(row.vaccine_record_id, row.child_vaccine_record_id)}
                    style={{cursor: 'pointer'}}
                  >
                    <TableCell>{row.vaccine_title}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{row.doses_completed ?? '-'}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{row.expiration_date ?? '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </ExpandedField>
        </div>

        <br />
        <Divider />
        <br />
        {this.props.Auth.role === "superadmin" || this.props.Auth.show_finance ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: 24 }}>
            <Button variant="contained" onClick={this.viewFutureInvoice}>View Future Invoice</Button>
            <Button variant="contained" onClick={this.sendFutureInvoice}>Send Future Invoice</Button>
            <Button variant="contained" onClick={this.refreshInvoice}>Create New Invoice</Button>
            <Button variant="contained" onClick={this.sendInvitation}>Send Payment Invite</Button>
          </div>
        ) : null}
        <div className="childForm">
          <TextField
            id="firstname"
            label="First Name"
            placeholder="First Name"
            error={this.state.data.firstname === ""}
            helperText={this.state.data.firstname === "" ? "This field is required" : ""}
            fullWidth
            value={this.state.data.firstname}
            onChange={this.handleChange}
          />

          <TextField
            id="lastname"
            label="Last Name"
            placeholder="Last Name"
            error={this.state.data.lastname === ""}
            helperText={this.state.data.lastname === "" ? "This field is required" : ""}
            fullWidth
            value={this.state.data.lastname}
            onChange={this.handleChange}
          />

          <FormControl fullWidth error={this.state.data.organisation_id === ""}>
            <InputLabel id="organisation-label">School</InputLabel>
            <Select
              labelId="organisation-label"
              id="organisation"
              value={this.state.data.organisation_id || ''}
              onChange={this.handleOrgChange}
              label="School"
              disabled
            >
              {this.state.organisations.map(row => (
                <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
              ))}
            </Select>
            {this.state.data.organisation_id === "" && <FormHelperText>This field is required</FormHelperText>}
          </FormControl>

          <FormControl fullWidth error={this.state.data.classes_id === ""}>
            <InputLabel id="classes-label">Class</InputLabel>
            <Select
              labelId="classes-label"
              id="classes"
              value={this.state.data.classes_id || ''}
              onChange={this.handleClassChange}
              label="Class"
            >
              {this.state.currentOrgClasses.map(rows => (
                <MenuItem key={rows.id} value={rows.id}>{rows.name}</MenuItem>
              ))}
            </Select>
            {this.state.data.classes_id === "" && <FormHelperText>This field is required</FormHelperText>}
          </FormControl>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Created on"
              value={this.state.data._created}
              disabled
              slotProps={{ textField: { fullWidth: true } }}
            />

            <DatePicker
              label="Birthday"
              value={this.state.data.birthday}
              onChange={this.handleBirthday}
              slotProps={{ textField: { fullWidth: true } }}
            />

            {this.props.Auth.edit_finance && <>
              <TextField
                id="nextyeardepo"
                label="Next Year Deposit"
                placeholder="Next Year Deposit"
                fullWidth
                value={this.state.data.nextyeardepo}
                onChange={this.handleChange}
              />

              <TextField
                id="futuredepo"
                label="Future Months Deposit"
                placeholder="Future Months Deposit"
                fullWidth
                value={this.state.data.futuredepo}
                onChange={this.handleChange}
              />
            </>}

            <DatePicker
              label="Start Date"
              value={this.state.data.startdate}
              onChange={this.handleStartDate}
              slotProps={{ textField: { fullWidth: true } }}
            />

            <div style={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center" }}>
              <DatePicker
                label="Drop Date"
                value={this.state.data.dropdate}
                onChange={this.handleDropDate}
                slotProps={{ textField: { fullWidth: true } }}
              />
              <IconButton title="Clear" onClick={this.handleRemoveDropDate}>
                <ClearIcon sx={{ color: blue[600] }} />
              </IconButton>
            </div>
          </LocalizationProvider>

          <FormControlLabel
            style={{ marginBottom: 16 }}
            control={
              <Checkbox
                id="photo"
                checked={!!this.state.data.usephoto}
                onChange={this.usePhoto}
              />
            }
            label="Photo Permission"
          />
          <FormControlLabel
            style={{ marginBottom: 16 }}
            control={
              <Checkbox
                id="acs"
                checked={!!this.state.data.acs}
                onChange={this.setACS}
              />
            }
            label="ACS"
          />

        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginTop: 8 }}>
          <TextField
            label="School Address (for Afterschool Program)"
            placeholder="School Address (for Afterschool Program)"
            fullWidth
            value={this.state.data.afterschool}
            onChange={this.handleAfterschool}
          />
          <TextField
            label="Notes"
            placeholder="Notes"
            fullWidth
            multiline
            rows={3}
            value={this.state.data.memo}
            onChange={this.handleMemo}
          />
        </div>
        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            justifyContent: "center",
            paddingTop: 20,
            paddingBottom: 20
          }}
        >
          <Button variant="contained" color="primary" onClick={this.saveData}>Save</Button>
          <Button variant="contained" color="primary" onClick={this.goPreviousPage}>Cancel</Button>
          <Button variant="contained" color="secondary" onClick={this.handleOpen}>Delete</Button>
        </div>
        <hr />
        <div className="programsFilter" style={{ marginTop: 16 }}>
          <h3>Programs</h3>
          <div>
            <TextField
              label="Filter by name"
              fullWidth
              value={this.state.programFilterValue}
              onChange={(event) => { this.setState({ programFilterValue: event.target.value }) }}
              size={"small"}
            />
          </div>
        </div>
        <Table size="small">
          <TableHead style={{ backgroundColor: '#f5f5f5'}}>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell style={{ width: 50 }}>Price</TableCell>
              <TableCell style={{ width: 50 }}>Active</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.plans
              .filter(row => row.name.toLowerCase().includes(this.state.programFilterValue.toLowerCase()))
              .map(row => (
                <TableRow hover key={row.id}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell style={{ width: 50 }}>{row.price}</TableCell>
                  <TableCell style={{ width: 50 }}>
                    <Switch
                      name={row.id.toString()}
                      checked={row.toggled}
                      onChange={this.handleToggle}
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            justifyContent: "center",
            paddingTop: 20,
            paddingBottom: 20
          }}
        >
          <Button variant="contained" color="primary" onClick={this.saveData}>Save</Button>
          <Button variant="contained" color="primary" onClick={this.goPreviousPage}>Cancel</Button>
          <Button variant="contained" color="secondary" onClick={this.handleOpen}>Delete</Button>
        </div>

        <Dialog
          open={this.state.opendialog}
          onClose={this.handleClose}
          maxWidth="xs"
        >
          <DialogContent>Delete child?</DialogContent>
          <DialogActions>{dialogActions}</DialogActions>
        </Dialog>

        { transferModal }
      </div>
    );
  }
}

export default inject("Auth")(observer(EditChild))
